var render = function render(){var _vm=this,_c=_vm._self._c;return _c('section',{staticClass:"clipboard"},[_c('p',{staticClass:"clipboard__label"},[_vm._v("Selected")]),_c('article',{staticClass:"clipboard__item"},[_c('img',{staticClass:"clipboard__image",attrs:{"src":`${_vm.imageURL}/${_vm.$store.state.mediaLibrary.selectedImage.imageKey}`}})])])
}
var staticRenderFns = []

export { render, staticRenderFns }